import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
type Sale = {
  name: string;
  city: string;
  product: string;
  minutesAgo: number;
};
const NAMES = ['Martín G.', 'Lucía P.', 'Diego R.', 'Valentina S.', 'Andrés M.', 'Camila F.', 'Sebastián L.', 'Florencia B.', 'Rodrigo C.', 'Sofía A.', 'Federico D.', 'Carolina T.', 'Nicolás V.', 'Agustina H.', 'Joaquín N.', 'Paula E.'];
const CITIES = ['Montevideo', 'Canelones', 'Maldonado', 'Salto', 'Paysandú', 'Rivera', 'Tacuarembó', 'Las Piedras', 'Ciudad de la Costa', 'Punta del Este', 'Mercedes', 'Florida', 'Durazno', 'Colonia', 'Minas', 'Treinta y Tres'];
const PRODUCTS = ['Megapack Sistema Libre de Clearing', 'Megapack + Blindaje Pro', 'Sistema Libre de Clearing'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generateSale(): Sale {
  return {
    name: pick(NAMES),
    city: pick(CITIES),
    product: pick(PRODUCTS),
    minutesAgo: Math.floor(Math.random() * 12) + 1
  };
}
export function SaleNotifications() {
  const [sale, setSale] = useState<Sale | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: ReturnType<typeof setTimeout>;
    let hideId: ReturnType<typeof setTimeout>;
    const show = () => {
      setSale(generateSale());
      hideId = setTimeout(() => {
        setSale(null);
        timeoutId = setTimeout(show, 6000 + Math.random() * 4000);
      }, 5500);
    };
    // First notification after a short delay
    timeoutId = setTimeout(show, 4000);
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(hideId);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <div className="fixed bottom-24 md:bottom-6 left-4 right-4 md:left-6 md:right-auto z-40 pointer-events-none" data-id="element-256">
      <AnimatePresence mode="wait" data-id="element-257">
        {sale && <motion.div key={`${sale.name}-${sale.city}-${sale.minutesAgo}`} initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto max-w-sm md:max-w-md bg-brand-light/95 backdrop-blur-md border border-gold/30 rounded-xl shadow-2xl shadow-black/40 px-4 py-3 flex items-start gap-3" role="status" aria-live="polite" data-id="element-258">
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-gold-gradient flex items-center justify-center shadow-gold-glow" data-id="element-259">
              <ShoppingBag className="w-5 h-5 text-brand-dark" data-id="element-260" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-261">
              <p className="text-sm font-semibold text-cream leading-tight" data-id="element-262">
                <span className="text-gold" data-id="element-263">{sale.name}</span> de {sale.city}
              </p>
              <p className="text-xs text-cream/80 mt-0.5 truncate" data-id="element-264">
                acaba de comprar el {sale.product}
              </p>
              <div className="flex items-center gap-1.5 mt-1.5 text-[11px] text-cream/60" data-id="element-265">
                <CheckCircle2 className="w-3 h-3 text-green-400" data-id="element-266" />
                <span data-id="element-267">Compra verificada · hace {sale.minutesAgo} min</span>
              </div>
            </div>

            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="flex-shrink-0 text-cream/50 hover:text-cream transition-colors p-1 -m-1" data-id="element-268">
              <X className="w-4 h-4" data-id="element-269" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}